import {
  Box,
  Button,
  Center,
  HStack,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PinInput,
  PinInputField,
  Text,
  Image,
} from '@chakra-ui/react'
import CustomButton from 'Components/CustomButton'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PospImages } from 'Assets/Posp'

interface IExamPassModal {
  isOpen: any
  score?: any
  total?: any
  minScore?: any
}
const ExamFailModal = ({ isOpen, score, total, minScore }: IExamPassModal) => {
  const navigate = useNavigate()

  return (
    <Modal
      onClose={() => {
        console.log('cant close')
      }}
      size='xl'
      isOpen={isOpen}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign='center' pt='16'>
          <Center>
            <Image src={PospImages.FailureIcon} width='80px' />
          </Center>
        </ModalHeader>

        <ModalBody textAlign='center'>
          <Box>
            <Box>
              <Box>
                <Text fontWeight='bold' fontSize='31px'>
                  Failed!
                </Text>
              </Box>
            </Box>
            {/* <Box>
              <Text>
                You have scored {score}/{total} in your Life Insurance Exam. Minimum passing
                marks required is {minScore}.
              </Text>
            </Box> */}
            <CustomButton
              buttonText='RE-TAKE THE EXAM AGAIN'
              buttonColor='#93C025'
              my='30px'
              handlerFunction={() => navigate('/sp-registration/examination-instruction')}
              fontWeight='medium'
              width='300px'
            />
          </Box>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default ExamFailModal
